import { S3LocationResponse } from "@/commons/models/S3Location";
import { AxiosResponse } from "axios";

/**
 * S3ファイルアップロード API 操作クラス
 */
export default class S3Uploads {
  /**
   * ### S3にファイルをアップロードする
   *
   * @param location S3ファイル格納場所情報
   * @param file 格納対象のファイル
   */
  public async uploadFile(location: S3LocationResponse, file: File): Promise<any> {
    // 送信情報を作成する
    const formData: FormData = this.createFormData(location, file);

    const response: AxiosResponse<any> = await window.axios.post(location.url, formData, {
      headers: {
        "content-type": "multipart/form-data"
      }
    });

    return response;
  }

  /**
   * ### S3にファイルをアップロードする
   *
   * @param location S3ファイル格納場所情報
   * @param file 格納対象のファイル
   */
  public async uploadBase64File(location: S3LocationResponse, base64File: string): Promise<Response> {
    const file: File = this.convertBase64ToFile(base64File);
    const response: Response = await this.uploadFile(location, file);

    return response;
  }

  /**
   * ### 送信データを作成する
   *
   * - ファイルは最後に追加しないとエラーになるので最後に追加している
   *
   * @param location S3ファイル格納場所情報
   * @param file 格納対象のファイル
   *
   * @returns 送信データ
   */
  public createFormData(location: S3LocationResponse, file: File): FormData {
    const formData: FormData = new FormData();
    for (const key in location.fields) {
      formData.append(key, location.fields[key]);
    }
    formData.append("file", file);

    return formData;
  }

  /**
   * ### Base64文字列からFileインスタンスに変換する
   *
   * @param base64File Base64文字列
   */
  public convertBase64ToFile(base64File: string) {
    // Base64文字列からコンテンツタイプを取得する
    const contentType = base64File.toString().slice(base64File.indexOf(":") + 1, base64File.indexOf(";"));

    // Base64文字列をバッファに変換して、バッファからFileインスタンスを作る
    const binary: string = atob(base64File.replace(/^.*,/, ""));
    const buffer: Uint8Array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      buffer[i] = binary.charCodeAt(i);
    }
    const file: File = new File([buffer.buffer], "fileName", { type: contentType });

    return file;
  }
}
